import { styled as muiStyled } from "@mui/material/styles";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { CardContent, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import UploadImage from "src/components/upload/dropzone/UploadImage";
import styled from "styled-components";
import device from "src/styles/device";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import Button from "src/components/core/Button";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    paddingBottom: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
}));

const UploadedPreview = styled.div`
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  width: 150px;
  height: 150px;
`;

const PreviewImage = styled.img`
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;

  @media ${device.mobileL} {
    height: 160px;
  }
`;

const RemoveButton = styled(IconButton)`
  position: absolute !important;
  top: 10px;
  right: 10px;
  background: rgb(255, 255, 255) !important;
  color: #e04132;
  width: 28px;
  height: 28px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 1);
    color: #c73529;
  }
`;

const UploadBox = styled.div`
  border: 2px dashed #d0d0d4;
  border-radius: 16px;
  padding: 12px;
  text-align: center;
  background: #fbfbfb;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 150px;
  height: 150px;

  &:hover {
    border-color: #e04132;
    background: #f9f9f9;
  }

  @media ${device.tabletL} {
    padding: 40px 20px;
    min-height: 150px;
  }

  @media ${device.mobileL} {
    padding: 32px 16px;
    min-height: 180px;
  }
`;

const UploadText = styled(Typography)`
  color: #666666;
  margin-top: 16px;
  text-align: center;
  font-weight: 500;
  font-size: 0.7rem !important;

  @media ${device.mobileL} {
    // font-size: 0.875rem;
    margin-top: 12px;
  }
`;

const UploadHelper = styled(Typography)`
  color: #999999;
  font-size: 0.625rem !important;
  margin-top: 8px;
  text-align: center;
  line-height: 1.4;

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const Modal = ({ descData = "", isOpen = false, onClose, onSubmit }) => {
  const initialTISIState = {
    code: null,
    qrCode: null,
    image: null,
  };
  const [TISI, setTISI] = useState(initialTISIState);

  const removeImage = (type) => {
    setTISI((prev) => ({ ...prev, [type]: null }));
  };

  const handleImageUpload = (file) => {
    if (file) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   // callBackFile(fileUpload[0], e.target.result);
      setTISI((prev) => ({
        ...prev,
        image: file,
      }));
    }
  };
  const handleQRUpload = (file) => {
    if (file) {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   // callBackFile(fileUpload[0], e.target.result);
      setTISI((prev) => ({
        ...prev,
        qrCode: file,
      }));
    }
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 740,
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        เพิ่ม มอก. ใหม่
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            borderRadius: "50%",
            border: "1px solid var(--lightgrey-color)",
            position: "absolute",
            right: 16,
            top: 16,
            color: "var(--primary-color)",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          px: 3,
          width: "100%",
          "& .MuiBox-root": {
            maxWidth: "530px",
            mx: "auto",
          },
        }}
      >
        <Grid container xs={8} mx="auto" mb={4} justifyContent="center">
          <Grid
            container
            justifyContent="center"
            xs={12}
            sx={{ textAlign: "center", py: 2 }}
          >
            <CardContent>
              {!TISI?.image ? (
                <UploadImage
                  callBackFile={handleImageUpload}
                  sizeFile={4194304} // 4MB
                  closeAlert={false}
                >
                  <UploadBox>
                    <PhotoOutlinedIcon
                      sx={{
                        fontSize: 45,
                        color: "#999999",
                        marginBottom: "8px",
                      }}
                    />
                    <UploadText>อัปโหลดรูปภาพ มอก.</UploadText>
                    <UploadHelper variant="caption">
                      รองรับไฟล์ JPG, PNG ขนาดไม่เกิน 4MB
                    </UploadHelper>
                  </UploadBox>
                </UploadImage>
              ) : (
                <UploadedPreview>
                  <PreviewImage
                    src={URL.createObjectURL(TISI?.image)}
                    alt="TISI preview"
                  />
                  <RemoveButton onClick={() => removeImage("tis")}>
                    <CloseIcon sx={{ fontSize: 22 }} />
                  </RemoveButton>
                </UploadedPreview>
              )}
            </CardContent>

            <CardContent>
              {!TISI?.qrCode ? (
                <UploadImage
                  callBackFile={handleQRUpload}
                  sizeFile={4194304} // 4MB
                  closeAlert={false}
                >
                  <UploadBox>
                    <PhotoOutlinedIcon
                      sx={{
                        fontSize: 45,
                        color: "#999999",
                        marginBottom: "8px",
                      }}
                    />
                    <UploadText>อัปโหลดรูปภาพคิวอาร์โค้ด</UploadText>
                    <UploadHelper variant="caption">
                      รองรับไฟล์ JPG, PNG ขนาดไม่เกิน 4MB
                    </UploadHelper>
                  </UploadBox>
                </UploadImage>
              ) : (
                <UploadedPreview>
                  <PreviewImage
                    src={URL.createObjectURL(TISI?.qrCode)}
                    alt="TISI preview"
                  />
                  <RemoveButton onClick={() => removeImage("qrCode")}>
                    <CloseIcon sx={{ fontSize: 22 }} />
                  </RemoveButton>
                </UploadedPreview>
              )}
            </CardContent>
          </Grid>

          <Grid container justifyContent="center" xs={12} sx={{ mb: 4 }}>
            <TextField
              required
              fullWidth
              size="medium"
              label="เลขที่ มอก."
              placeholder="กรุณากรอกเลขที่ มอก."
              value={TISI?.code}
              onChange={({ target }) =>
                setTISI((tisi) => ({ ...tisi, code: target.value }))
              }
            />
          </Grid>
          <Grid container justifyContent="center" xs={12} sx={{ mb: 4 }}>
            <TextField
              required
              fullWidth
              size="medium"
              label="แนบลิ้ง รายละเอียด มอก."
              placeholder="กรุณาแนบลิ้ง รายละเอียด มอก."
              value={TISI?.url}
              onChange={({ target }) =>
                setTISI((tisi) => ({ ...tisi, url: target.value }))
              }
            />
          </Grid>

          <Button
            variant="contained"
            size="large"
            disabled={!TISI?.image || !TISI?.qrCode || !TISI?.code}
            onClick={() => onSubmit(TISI)}
            sx={{ width: "100%", maxWidth: 160, borderRadius: 4, mx: 2 }}
          >
            สร้าง มอก.
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
